
export enum TraegerAntragBeType {
  Erst,
  Veraenderung,
  Erweiterung
}

export enum AntragBEContentType {
  Reset,
  Start,
  Ansprechpartner,
  He_Stamm,
  He_PaedL,
  Ue_Strukt,
  Ue_Stamm,
  Ue_TeamL,
  Ue_Betreuung,
  Ue_Konzeption,
  He_CheckList,
  Einreichen
}

export namespace AntragBEContentType {

  export function getValues(): AntragBEContentType[] {
    const values = Object.values(AntragBEContentType) as string[];
    const results = [];
    for (let i = 0; i < values.length - 1; i++) {
      results.push(values[i]);
    }

    return results;
  }
}


// -------------------

export enum AntragBEContentSubType {
  Traegernachweis,
  Wirtschaftsplan,
  Liquiditaetsnachweis,
  Raumplaene,
  Lageplaene,
  Mietvertraege,
  Bauaufsichtsbehoerde,
  Baugenehmigung,
  Veterinaer,
  Gewerbeaufsichtsamt,
  Sonstiges
}

export namespace AntragBEContentSubType {

  export function getValues(): AntragBEContentSubType[] {
    const values = Object.values(AntragBEContentSubType) as string[];
    const results = [];
    for (let i = 0; i < values.length - 1; i++) {
      results.push(values[i]);
    }

    return results;
  }
}

// -------------------

export enum TraegerAntragBeEntscheidung {
  Nicht_Eingereicht = 'Nicht Entschieden',
  Angenommen = 'Angenommen',
  Abgelehnt = 'Abgelehnt'
}

export namespace TraegerAntragBeEntscheidung {
  export function keys(): any[] {
    const values = Object.values(TraegerAntragBeEntscheidung) as string[];
    const results = [];
    for (let i = 0; i < values.length - 1; i++) {
      if (typeof values[i] === 'string') {
        results.push({ id: i, name: values[i].replace('_', ' ') });
      }
    }

    return results;
  }

  export function getValues(): TraegerAntragBeEntscheidung[] {
    const values = Object.values(TraegerAntragBeEntscheidung) as string[];
    const results = [];
    for (let i = 0; i < values.length - 1; i++) {
      results.push(values[i]);
    }

    return results;
  }
}


// -------------------


export enum TraegerAntragBeStatus {
  Nicht_Eingereicht = 'Nicht Eingereicht',
  Eingereicht = 'Eingereicht',
  Bearbeitung = 'Bearbeitung',
  Geschlossen = 'Geschlossen'
}

export namespace TraegerAntragBeStatus {
  export function keys(): any[] {
    const values = Object.values(TraegerAntragBeStatus) as string[];
    const results = [];
    for (let i = 0; i < values.length - 1; i++) {
      if (typeof values[i] === 'string') {
        results.push({ id: i, name: values[i].replace('_', ' ') });
      }
    }

    return results;
  }

  export function getValues(): TraegerAntragBeStatus[] {
    const values = Object.values(TraegerAntragBeStatus) as string[];
    const results = [];
    for (let i = 0; i < values.length - 1; i++) {
      results.push(values[i]);
    }

    return results;
  }
}


// -------------------


export enum AntragBeReadStatus {
  Ungelesen = 'Ungelesen',
  Gelesen = 'Gelesen'
}

export namespace AntragBeReadStatus {
  export function keys(): any[] {
    const values = Object.values(AntragBeReadStatus) as string[];
    const results = [];
    for (let i = 0; i < values.length - 1; i++) {
      if (typeof values[i] === 'string') {
        results.push({ id: i, name: values[i].replace('_', ' ') });
      }
    }

    return results;
  }

  export function getValues(): AntragBeReadStatus[] {
    const values = Object.values(AntragBeReadStatus) as string[];
    const results = [];
    for (let i = 0; i < values.length - 1; i++) {
      results.push(values[i]);
    }

    return results;
  }
}
